module.exports = __webpack_public_path__ + "static/flower-55a9d08e182bc33eca0592e12ebed383.svg";